import { useContext } from 'react'
import { AlertContext } from '.'
import type { AlertContextType } from './AlertContext'

export const useAlert = (): AlertContextType => {
  const context = useContext(AlertContext)
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider')
  }
  return context
}
